import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionSold = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="1 1 23 22" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5201 7.35359L12.1665 15.7071L7.31299 10.8536L8.02009 10.1465L12.1665 14.2929L19.813 6.64648L20.5201 7.35359Z"
      fill="currentColor"
    />
  </svg>,
  'TransactionSold'
);
